/** Allow only https URLs for CSS background-image usage. */
export function safeCssBackgroundImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== 'https:') return null;
    return trimmed;
  } catch {
    return null;
  }
}

/** Builds a safe `url("...")` fragment for a CSS custom property. */
export function cssUrlValue(url: string): string {
  return `url("${url.replace(/"/g, '%22')}")`;
}
